import { render } from "./Forbidden.vue?vue&type=template&id=68a04434"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"
script.render = render

export default script